<nz-avatar
  class="portrait"
  [nzSrc]="portraitUrl()"
  nz-dropdown
  [nzDropdownMenu]="portraitMenu"
  [nzShape]="'circle'"
></nz-avatar>

<nz-dropdown-menu #portraitMenu="nzDropdownMenu">
  <ul nz-menu>
    <li nz-menu-item (click)="onMyAccountClick()">
      <div class="horizontal">
        <span nz-icon style="font-size: 18px" class="material-symbols-rounded">account_circle</span>
        <span>My Account</span>
      </div>
    </li>
    <li nz-menu-item (click)="onUsageBillingClick()">
      <div class="horizontal">
        <div class="horizontal">
          <span nz-icon style="font-size: 18px" class="material-symbols-rounded">account_balance_wallet</span>
          <span>Usage & Billing</span>
        </div>
      </div>
    </li>

    <li nz-menu-item (click)="onLogoutClick()">
      <div class="horizontal">
        <span nz-icon style="font-size: 18px" class="material-symbols-rounded">logout</span>
        <span>Logout</span>
      </div>
    </li>
  </ul>
</nz-dropdown-menu>
